import * as d3 from 'd3';
import { drawColonialGrillsOculus } from './drawColonialGrillsOculus';
import { drawPrairieGrillsOculus } from './drawPrairieGrillsOculus';
import { drawShortFractionalGrillsOculus } from './drawShortFractionalGrillsOculus';
import { drawTallFractionalGrillsOculus } from './drawTallFractionalGrillsOculus';
import { drawQueenAnneGrillsOculus } from './drawQueenAnneGrillsOculus';
import { drawVictorianGrillsOculus } from './drawVictorianGrillsOculus';

export function drawGrillsOculus(svg, indexWindow = 1, x, y, width, height, frameWidth = 10, doorData, top = false, radiusX = width / 2, radiusY = height / 2, outerShape = 'Rect' ) {

  let ins = '';
  if (top) { ins = 'Top'; }
  
  const grillType = `grillType${ins}${indexWindow}`;
  const grillTypeValue = doorData?.grills?.[grillType] || "Unknown";

  if (grillTypeValue === "None"){
     return;
  }

  const grillsPattern = `grillsPattern${ins}${indexWindow}`;
  const grillsPatternValue = doorData?.grills?.[grillsPattern]?.value || "Unknown";

  const grillsSize = `grillsSize${ins}${indexWindow}`;
  const grillsSizeValue = doorData?.grills?.[grillsSize];

  const hashSize = {
      '5/16"': 0.8,   // 0.3125
      '5/8"': 1.5,    // 0.625
      '3/4"': 2,      // 0.75
      '7/8"': 2.5,    // 0.875
      '1"': 3,        // 1.0
      '1 1/4"': 3.5,  // 1.25
      '2"': 4         // 2.0
    };
    
  const glassDividers = `glassDividers${ins}${indexWindow}`;
  const glassDividersValue = doorData?.grills?.[glassDividers];
 
    const glassDividersVertical = `glassDividersVertical${ins}${indexWindow}`;
    const glassDividersHorizontal = `glassDividersHorizontal${ins}${indexWindow}`;
    const glassDividersVerticalValue = doorData?.grills?.[glassDividersVertical] || 0;
    const glassDividersHorizontalValue = doorData?.grills?.[glassDividersHorizontal] || 0;

    const grillsColor = doorData.flipped ? doorData?.grills?.exteriorFinish.value || 'white' :
                                           doorData?.grills?.interiorFinish.value || 'white' ;

    if (grillsPatternValue === 'Colonial') {
      drawColonialGrillsOculus(svg,
        x, y, width, height, frameWidth,
        parseInt(glassDividersHorizontalValue),
        parseInt(glassDividersVerticalValue),
        grillsColor,  'black', 0.2, hashSize[grillsSizeValue], radiusX, radiusY, outerShape);
    }

    if (grillsPatternValue === 'Prairie') {
      drawPrairieGrillsOculus(svg,
        x, y, width, height, frameWidth,
        0.15, grillsColor, 'black', 0.2, hashSize[grillsSizeValue], radiusX, radiusY, outerShape);
    }

    if (grillsPatternValue === 'Short Fractional') {
      drawShortFractionalGrillsOculus(svg,
        x, y, width, height, frameWidth,
        grillsColor, 'black', 0.2, true, true, hashSize[grillsSizeValue], radiusX, radiusY, outerShape);
    }

    if (grillsPatternValue === 'Tall Fractional') {
      drawTallFractionalGrillsOculus(svg,
        x, y, width, height, frameWidth,
        grillsColor, 'black', 0.2,  hashSize[grillsSizeValue], 0.6, radiusX, radiusY, outerShape);
    }

    if (grillsPatternValue === 'Queen Anne') {
      drawQueenAnneGrillsOculus(svg,
        x, y, width, height, frameWidth,
        parseInt(glassDividersVerticalValue), parseInt(glassDividersHorizontalValue),              // ver/hor
        grillsColor, 'black', 0.2,          // fillColor          // strokeColor
        hashSize[grillsSizeValue],                  // grillThickness
        0.33,
        radiusX,
        radiusY,
        outerShape
        );
    }

    if (grillsPatternValue === 'Victorian') {
      drawVictorianGrillsOculus(svg,
        x, y, width, height, frameWidth,
        3,3,//parseInt(glassDividersVerticalValue), parseInt(glassDividersHorizontalValue),              // ver/hor
        grillsColor, 'black', 0.2,          // fillColor          // strokeColor
        hashSize[grillsSizeValue],                  // grillThickness
        radiusX,
        radiusY,
        outerShape
        );
    }
  
  }//drawGrillsOculus
  

  